<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/static/eduPass.jpeg"
                    alt="eduPass Admin"
                    width="180"
                    height="auto"
                  />
                  <!-- <h1 class="flex my-4 primary--text">
                    Company
                  </h1>-->
                </div>
                <v-form>
                  <v-text-field
                    append-icon="school"
                    name="schoolId"
                    label="School Id (Optional for admin users)"
                    type="text"
                    v-model="schoolId"
                  ></v-text-field>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="login.username"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    v-model="login.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  block
                  color="primary"
                  @click="loginSubmitForm"
                  :loading="loading"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import APIAuth from "@/mixins/APIAuth";
import APIAdmin from "@/mixins/APIAdmin";
export default {
  mixins: [APIAuth, APIAdmin],
  data: () => ({
    loading: false,
    login: {
      username: "",
      password: ""
    },
    schoolId: ""
  }),
  created() {
    if (localStorage.token) {
      let redirect = {};
      if (localStorage.active_user) {
        let object = JSON.parse(localStorage.active_user);
        if (object.role === 6) {
          let moduels =
            object.permissions ||
            object.modules ||
            object.company.modules ||
            [];
          if (moduels.includes("track")) {
            redirect["path"] = "/dashboard";
          } else if (moduels.includes("historical")) {
            redirect["path"] = "/historical-visitors";
          } else if (moduels.includes("quick_code")) {
            redirect["path"] = "/quickpins";
          } else if (moduels.includes("policy")) {
            redirect["path"] = "/policies";
          } else if (moduels.includes("resource")) {
            redirect["path"] = "/resources";
          }
        }
        this.$router.push(redirect.path || "/dashboard");
      } else {
        this.$router.push("/dashboard");
      }
    }
  },
  methods: {
    loginSubmitForm: async function() {
      if (this.$cookies.isKey("server") || this.schoolId) {
        localStorage.port = this.$cookies.isKey("server") || this.schoolId;
        this.loginFromCache();
        return;
      }
      this.loading = true;
      try {
        this.login.username = this.login.username.toLowerCase();
        let response = await this.authCompanyLogin(this.login);
        let res = response;
        if (res.status === 200) {
          this.procceedWithloginResponse(res);
        }
      } catch (error) {
        this.$toast.error("Failed to login!", "Error", {
          position: "topCenter"
        });
        this.loading = false;
      }
    },
    loginFromCache: async function() {
      try {
        localStorage.port =
          (await this.$cookies.get("server")) || this.schoolId;
        this.loading = true;
        this.login.username = this.login.username.toLowerCase();
        let response = await this.adminLogin(this.login, localStorage.port);
        if (response) {
          let data = Object.assign({}, response);
          response = {};
          response["data"] = data;
          this.procceedWithCacheResponse(response);
        }
      } catch (error) {
        this.$toast.error("Failed to login!", "Error", {
          position: "topCenter"
        });
        this.loading = false;
      }
    },
    procceedWithCacheResponse: async function(res) {
      localStorage.clear();
      location.reload();

      if (this.schoolId) {
        localStorage.port = this.schoolId;
      } else {
        localStorage.port = this.$cookies.get("server");
      }
      localStorage.token = res.data.token;
      localStorage.active_user = JSON.stringify(res.data);

      let self = this;
      setTimeout(() => {
        location.reload();
        self.$toast.success("Welcome!", "Successfully logged in to eduPass", {
          position: "topCenter"
        });
      }, 1000);
    },
    procceedWithloginResponse: async function(res) {
      if (window.location.href.includes("portal.edpass.co")) {
        console.log("Welcome to portal login");
      } else if (window.location.href.includes("demo.edpass.co")) {
        console.log("Welcome to demo login");
      } else if (window.location.href.includes("localhost")) {
        console.log("Welcome to demo login");
      } else if (window.location.href.includes("68.183.181.178:2004")) {
        console.log("Welcome to demo secondary login");
      } else if (!window.location.href.includes(res.data.domain)) {
        if (res.data.domain == "demo@edpass.com") {
          console.log("demo login");
        } else {
          localStorage.clear();
          location.reload();
          return;
        }
      }
      localStorage.token = res.data.company_user.token;
      if (this.schoolId) {
        localStorage.port = this.schoolId;
      } else {
        localStorage.port = res.data.port;
      }
      localStorage.active_user = JSON.stringify(res.data);
      this.$cookies.set("server", localStorage.port, -1);
      let self = this;
      setTimeout(() => {
        switch (res.data.company_user.role) {
          case 1:
            location.reload();
            self.$toast.success(
              "Welcome!",
              "Successfully logged in to eduPass",
              { position: "topCenter" }
            );
            break;
          case 2:
            break;
          default:
        }
      }, 1000);
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
